<template>
  <card :is-loading="isLoading" :page-title="pageTitle" :page-icon="pageIcon">
    <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-toolbar
              flat
              color="primary"
              dark
          >
            <v-toolbar-title class="text-left" style="color: #ffffff">Settings</v-toolbar-title>
          </v-toolbar>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>
                mdi-account
              </v-icon>
              Company
            </v-tab>
            <v-tab>
              <v-icon left>
                mdi-newspaper
              </v-icon>
              License
            </v-tab>
            <v-tab>
              <v-icon left>
                mdi-cash
              </v-icon>
              AmarPay
            </v-tab>
            <v-tab>
              <v-icon left>
                mdi-lock
              </v-icon>
              USD to BDT
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_name"
                          :rules="requiredFieldRule"
                          label="Company Name"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-textarea
                          outlined
                          rows="2"
                          label="Company Description"
                          color="deep-purple accent-4"
                          v-model="settings.c_description"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-textarea
                          outlined
                          rows="2"
                          label="Company Address 1"
                          color="deep-purple accent-4"
                          v-model="settings.c_add1"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-textarea
                          outlined
                          rows="2"
                          label="Company Address 2"
                          color="deep-purple accent-4"
                          v-model="settings.c_add2"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="email"
                          v-model="settings.c_email1"
                          label="Email 1"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="email"
                          v-model="settings.c_email2"
                          label="Email 2"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_phone"
                          label="Phone"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_trade_license_no"
                          label="Trade License"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_etin_no"
                          label="ETIN NO"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_amarpay_store_id"
                          label="Store ID"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="text"
                          v-model="settings.c_amarpay_signature_key"
                          label="Signature Key"
                      />
                    </v-col>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-select
                          dense
                          :items="items"
                          v-model="settings.c_amarpay_sandbox"
                          label="Environment"
                          item-text="text"
                          item-value="value"
                          outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" offset-md="2">
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="number"
                          class="right-align-text"
                          v-model="settings.usd_to_bdt"
                          label="1USD=BDT"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
          <v-card-actions>
            <v-spacer/>
            <save-button text="Save Changes" @onButtonClick="onSaveChangesHandler()"/>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </card>
</template>

<script>
import Card from "@/components/Card";
import Validation from "@/components/mixins/Validation";
import BaseOutlinedButton from "@/components/buttons/BaseOutlinedButton";
import SystemSetting from "@/services/SystemSetting";
import SaveButton from "@/components/buttons/SaveButton";

export default {
  name: "SystemSettings",
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - System Settings | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  mixins: [Validation],
  components: {SaveButton, BaseOutlinedButton, Card},
  data() {
    return {
      isLoading: false,
      pageTitle: "System Settings",
      pageIcon: "mdi-cog",
      validLogin: true,
      settings: {},
      items:[
        {text: 'Sandbox', value: 1},
        {text: 'Production', value: 0}
      ]
    }
  },
  computed: {},
  mounted() {
    this.loadSystemSettings()
  },
  methods: {
    async loadSystemSettings() {
      try {
        let {data} = await SystemSetting.get();
        this.settings = data;
      } catch (errors) {
        console.log('');
      }
    },
    async onSaveChangesHandler() {
      try {
        let {data} = await SystemSetting.update(this.settings);
        this.setSnackBar({text:data.message, type:'info'})
        await this.loadSystemSettings();
      } catch (errors) {
        console.log('');
      }
    },
    setSnackBar({ text, type }) {
      this.$store.commit("SET_SNACKBAR", { text, type });
    },
  }
}
</script>

<style scoped>

</style>